import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 365/490;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 365 490" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <g stroke="#0AB3A6">
                <path d="M350.5 128.5h-110v-115H42c-15.74 0-28.5 12.76-28.5 28.5v406c0 15.74 12.76 28.5 28.5 28.5h280c15.74 0 28.5-12.76 28.5-28.5V128.5z" strokeWidth="27"/>
                <path d="M254 19l92 96" strokeWidth="26" strokeLinecap="square"/>
            </g>
            <rect fill="#0AB3A6" x="77" y="212" width="214" height="22" rx="10.5"/>
            <rect fill="#0AB3A6" x="77" y="297" width="214" height="22" rx="10.5"/>
            <rect fill="#0AB3A6" x="77" y="382" width="214" height="22" rx="10.5"/>
        </g>
    </svg>
)

export default class IconNiftyDoc extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
